import { render, staticRenderFns } from "./EntityBadge.vue?vue&type=template&id=c76c5030&"
import script from "./EntityBadge.vue?vue&type=script&lang=js&"
export * from "./EntityBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports